import React, { useEffect, useState } from "react";
import TableDesk from "../component/DeskTable";
import MobileCard from "../component/MobileCard";
import { vasthuUrl } from "../component/Api";
import { UseAuth } from "../context/Auth";
import { Alert, Spinner } from "react-bootstrap";
import { CleaningServices } from "@mui/icons-material";

const AdminCrmListDetails = () => {
  // const { token } = UseAuth();
  const token = window.sessionStorage.getItem("token");
  const [crmData, setCrmData] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const alert = (msg) => {
    setMessage(msg);
    setTimeout(() => {
      setMessage("");
    }, 4000);
  };
  useEffect(() => {
    setLoading(true);
    try {
      vasthuUrl
        .get(`/data/getallcrms`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          console.log("crm", res.data.message);
          setCrmData(res.data);
          setLoading(false);
        });
    } catch (e) {
      alert("SERVER ERROR");
      setLoading(false);
    }
  }, []);

  console.log('crmData',crmData);
  return (
    <React.Fragment>
      <center>
        <h4>
          <u>CRM DETAILS</u>
        </h4>
      </center>
      {message && (
        <Alert variant="info" className="text-center">
          {message}
        </Alert>
      )}
      {!loading ? (
        crmData.length > 0 ? (
          <>
            <TableDesk data={crmData} />
            <MobileCard data={crmData} />
          </>
        ) : (
          <center>
            <h5>No CRM Found</h5>
          </center>
        )
      ) : (
        <center>
          <Spinner animation="border" variant="warning" />
        </center>
      )}
    </React.Fragment>
  );
};
export default AdminCrmListDetails;
